<template>
  <section class="rank-content">
    <div class="main">
      <div class="second">
        <h3 class="main-title">&lt;<span>SCOREBOARD</span>&gt;</h3>
         <ul class="table">
            <li class="thead">
              <a>
                <span >Ranking</span>
                <span >{{ctfMode == 'teams'?team_:player_}}</span>
                <span >Avatar</span>
                <span >Points</span>
                <span >Last Update</span>
              </a>
            </li>
            <li class="tr" v-for="(r, index) in result">
              <router-link :id="'rank_'+r.tid" :to="r.tid && '/team/'+ r.tid || ''">
                <span v-if="!isStart">#</span>
                <span v-else >{{index + 1}}</span>
                <span :title="r.name">
                  {{r.name}}
                </span>
                <span ><img :src="r.logo" alt="" height="80%"/> </span>
                <span >{{r.rating}}</span>
                <span >{{formatTime(r.last_solve_time)}}</span>
              </router-link>
            </li>
          </ul>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { formatTime } from '@/utils'
  import { getCountryName } from '@/utils/country.js'
  import { rank } from '@/utils/api.js'
  import i18n from '@/i18n'
  import bus from '@/utils/event_bus.js'

  // let teams = null

  export default {
    data () {
      return {
        result: [],
        isStart: false
      }
    },
    computed: {
      ...mapState(['v_locale', 'startTime', 'ctfMode']),
      ...mapGetters([]),
      ...i18n.map([
        'rank_table_', 'rank_', 'team_',
        'location_', 'score_', 'solved_', 'finishedTime_', 'player_'
      ])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      getcn: getCountryName,
      init () {
        rank()
          .then((data) => {
            const arr = data.data
            // Doesn't seems to be useful
            // if (!teams) {
            //   const teamDict = {}
            //   for (let i of arr) {
            //     i.last_solve_time = Date.parse_iso(i.last_solve_time)
            //     teamDict[i.tid] = i.name
            //   }
            //   teams = teamDict
            // }
            this.result = arr
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      }
    },
    created () {
      this.init()
      this.isStart = Date.now() >= this.startTime
      bus.$on('UPDATE', this.init)
    },
    beforeDestroy () {
      bus.$off('UPDATE', this.init)
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/rank.vue